export const OUTREACH_RECIPIENTS = ["prescriber", "member", "pharmacy", "servicing_provider", "authorized_representative"] as const;

export type OutreachRecipientType = (typeof OUTREACH_RECIPIENTS)[number];

export const INBOUND_SENDERS = ["authorized_representative", "prescriber", "member", "pharmacy", "other", "servicing_provider"] as const;

export type InboundSenderType = (typeof INBOUND_SENDERS)[number];

export type RecipientType = OutreachRecipientType | InboundSenderType | "fax_sender";

export const FAX_ENABLED_RECIPIENTS: RecipientType[] = ["prescriber", "fax_sender", "pharmacy", "servicing_provider"];

/**
 * @deprecated use `RecipientType` instead
 */
export enum CommunicationRecipientType {
  AuthorizedRepresentative = "authorized_representative",
  Member = "member",
  Prescriber = "prescriber",
  FaxSender = "fax_sender",
  Pharmacy = "pharmacy",
  ServicingProvider = "servicing_provider",
  Other = "other",
}

export enum CommunicationMethod {
  Email = "email",
  Fax = "fax",
  Mail = "mail",
  Phone = "phone",
}

export const LETTER_COMMUNICATION_METHODS: CommunicationMethod[] = [
  CommunicationMethod.Email,
  CommunicationMethod.Fax,
  CommunicationMethod.Mail,
];

export enum CommunicationStatus {
  Created = "created",
  InProgress = "in_progress",
  Succeed = "succeeded",
  Failed = "failed",
}

export const COMMUNICATION_STATUS_LABEL: Record<CommunicationStatus, string> = {
  [CommunicationStatus.Created]: "Created",
  [CommunicationStatus.InProgress]: "In Progress",
  [CommunicationStatus.Succeed]: "Succeeded",
  [CommunicationStatus.Failed]: "Failed",
}

export enum CommunicationType {
  AorConfirmationRequest = "aor_confirmation_request",
  AppealAcknowledgement = "appeal_acknowledgement",
  DeterminationNotification = "determination_notification",
  ExtensionLetter = "extension_letter",
  ExternalAppealConfirmation = "external_appeal_confirmation",
  InboundCommunication = "inbound_communication",
  MedicaidEnrollmentNotification = "medicaid_enrollment_notification",
  OutreachCaseDetailsClarification = "outreach_case_details_clarification",
  OutreachCaseInitiation = "outreach_case_initiation",
  OutreachCloseCaseNotification = "outreach_close_case_notification",
  OutreachIneligibleFaxNotification = "outreach_ineligible_fax_notification",
  OutreachMissingInformationRequest = "outreach_missing_information_request",
  PostDeterminationNotification = "post_determination_notification",
  PreDenialNotification = "pre_denial_notification",
  PreDecisionDiscussion = "pre_decision_discussion",
  PostReviewDiscussionCallback = "post_review_discussion_callback",
  PostReviewDiscussionNotification = "post_review_discussion_notification",
  SupportingStatementRequest = "supporting_statement_request",
}

export const PHONE_OUTREACH_OUTCOMES = [
  "left_secure_voice_mail",
  "unable_to_leave_secure_voice_mail",
  "fax_requested",
  "call_back_requested",
  "obtained_missing_information",
  "member_successfully_notified",
  "discussed_with_prescribing_authority",
  "no_answer_unable_to_connect",
  "discussed_with_office_staff",
  "other",
] as const;

export type PhoneOutreachOutcome = (typeof PHONE_OUTREACH_OUTCOMES)[number];
